import { Component, OnInit, ChangeDetectorRef, OnDestroy } from "@angular/core";
import { CallCenterService } from "src/app/services/call-center.service";
import { CommonService } from "src/app/services/common.service";
import { AskApolloService } from "src/app/services/ask-apollo.service";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { MessageServiceService } from "src/app/services/message-service.service";
import { HealthCheckService } from "src/app/services/health-check.service";
import { specialityData } from "src/app/models/common-model";
import { Subscription } from "rxjs";

@Component({
  selector: "app-walking",
  templateUrl: "./walking.component.html",
  styleUrls: ["./walking.component.scss"],
})
export class WalkingComponent implements OnInit, OnDestroy {
  callStatusForm: FormGroup;
  selectedUHIDDetails: any;
  isNewUser: boolean = false;
  callType: number;
  loadingFlag: boolean = false;
  submitted: boolean;
  citiesData: any[];
  clinicsData: any[];
  specialitiesData: any[];
  doctorsData: any[];
  isAppointmentCreatedSuccessfully = false;
  callerStatusAutoId = 0;
  isSelectedCallBackOption = false;
  isInboundCallNewUser = false;
  isSelectedStatusUpdate = false;
  isSelectedAppointment = false;
  selectedCallStatusName;
  selectedCallStatusId;
  selectedAppointmentType = 1;
  selectedHospitalType = 2;
  selectedCity;
  selectedHospital;
  selectedSpeciality;
  selectedDoctor;
  walkinData: Subscription;
  currentUserBU: any;

  constructor(
    private callCenterService: CallCenterService,
    private messageService: MessageServiceService,
    private askApolloService: AskApolloService,
    private hcService: HealthCheckService,
    private formBuilder: FormBuilder,
    private ref: ChangeDetectorRef,
    private commonService: CommonService
  ) {}

  ngOnInit() {
    this.currentUserBU = JSON.parse(
      localStorage.getItem("LOGGED_USER_INFO")
    ).bussinessUnitName;
    this.callStatusForm = this.formBuilder.group({
      callBackDate: [""],
      callBackTime: [""],
      remarks: ["", Validators.required],
      subDisposition: ["", [Validators.required, Validators.min(1)]],
      city: ["", [Validators.required]],
      clinic: ["", [Validators.required]],
      speciality: ["", [Validators.required]],
      doctor: ["", [Validators.required]],
    });

    this.CheckPrimaryCases();
  }

  ngOnDestroy() {
    this.walkinData.unsubscribe();
  }

  leadId;
  CheckPrimaryCases() {
    //this method get the selected call status data from service
    this.walkinData = this.callCenterService.selectedCallStatus.subscribe(
      (value) => {
        this.leadId = value.LeadId;
        this.isNewUser = value.IsNewUser;
        this.callType = value.CallTypeId;
        this.callerStatusAutoId = value.CallerStatusAutoId;
        this.selectedUHIDDetails = value.UHIDDetails;
        this.selectedCallStatusId = value.CallStatus["callCenterStatusId"];
        this.selectedCallStatusName = value.CallStatus["statusName"];
        this.getSubDispositionsData(this.selectedCallStatusId);
      }
    );
  }

  DispositionBU(index, item) {
    return item.name;
  }

  subDispositionsData = [];
  getSubDispositionsData(callStatusId) {
    this.loadingFlag = true;
    this.commonService.FetchAllSubDispositions(callStatusId).subscribe(
      (res: any) => {
        if (res && res.response && res.response.length > 0) {
          this.subDispositionsData = res.response;
        } else {
          this.subDispositionsData = [];
        }
        this.getAllCities();
        this.loadingFlag = false;
      },
      (error) => {
        this.messageService.showErrorMessage(
          "Unable to retrieve sub dispositions data from server "
        );
      }
    );
  }
  CityByName(index, item) {
    return item.name;
  }

  getAllCities() {
    this.loadingFlag = true;
    this.citiesData = [];
    if (this.currentUserBU != "Dialysis") {
      this.askApolloService
        .getAllCities(this.selectedAppointmentType, this.selectedHospitalType)
        .subscribe(
          (res: any) => {
            if (
              res &&
              res.response &&
              res.response.citiesList &&
              res.response.citiesList.length > 0
            ) {
              this.citiesData = res.response.citiesList;
            } else {
              this.messageService.showErrorMessage("No data found.");
            }
            this.loadingFlag = false;
          },
          (error) => {
            this.loadingFlag = false;
            this.messageService.showErrorMessage(
              "Unable to retrieve city data from server "
            );
          }
        );
    } else {
      this.callCenterService.getDialysisCities().subscribe(
        (res) => {
          if (res && res.response && res.response.length > 0) {
            let rawAreaCode = res.response;
            //console.log(this.areaCode,"Pincode")
            let idModified = rawAreaCode.map((obj) => {
              return {
                id: obj.id,
                name: obj.cityName,
              };
            });
            this.citiesData = idModified;
          }
          this.loadingFlag = false;
        },
        (error) => {
          this.loadingFlag = false;
          this.messageService.showError();
        }
      );
    }
  }

  ClinicByName(index, item) {
    return item.name;
  }

  getClinicsOnCityId(cityId) {
    this.loadingFlag = true;
    this.clinicsData = [];
    if (cityId && this.currentUserBU != "Dialysis") {
      this.selectedCity = cityId;
      this.askApolloService
        .getClinicsOnCityId(
          this.selectedAppointmentType,
          this.selectedHospitalType,
          cityId
        ) // appttype, hospitaltype, cityid
        .subscribe(
          (res: any) => {
            if (res.response.hospitalList.length > 0) {
              this.clinicsData = res.response.hospitalList;
            } else {
              this.messageService.showErrorMessage(
                "No clinics available for selected city."
              );
            }
            this.loadingFlag = false;
          },
          (error) => {
            this.loadingFlag = false;
            this.messageService.showErrorMessage(
              "No clinics available for selected city. Please Contact Admin."
            );
          }
        );
    } else {
        if(cityId == -1){
          this.loadingFlag = false;
          this.clinicsData = [{ id: -1, name: "Not Mentioned" }];
        }
        else
        {
      this.callCenterService
        .getDialysisClinicsCityWise(parseInt(cityId))
        .subscribe(
          (res: any) => {
            if (res && res.response && res.response.length > 0) {
              let rawAreaCode = res.response;
              let idModified = rawAreaCode.map((obj) => {
                return {
                  id: obj.autoId,
                  name: obj.clinicName,
                };
              });
              this.clinicsData = idModified;
            }
            console.log(this.clinicsData, "Dialysis");
            this.loadingFlag = false;
          },
          (error) => {
            this.loadingFlag = false;
            this.messageService.showError();
          }
        );
        }
    }
  }

  specialitiesByName(index, item) {
    return item.name;
  }

  getSpecialities(hospitalId) {
    this.loadingFlag = true;
    this.specialitiesData = [];
    if (hospitalId && this.currentUserBU != "Dialysis") {
      this.selectedHospital = hospitalId;
      this.askApolloService
        .getSpecialitiesOnHospitalId(this.selectedHospitalType, hospitalId) // hospitaltype, hospitalid
        .subscribe(
          (res: any) => {
            if (res.response.specilaityList.length > 0) {
              this.specialitiesData = res.response.specilaityList;
            } else {
              this.specialitiesData = [];
              this.messageService.showErrorMessage(
                "No speciality available for selected clinic."
              );
            }
            this.loadingFlag = false;
          },
          (error) => {
            this.loadingFlag = false;
            this.messageService.showErrorMessage(
              "No speciality available for selected clinic. Please Contact Admin."
            );
          }
        );
    } else {
      this.loadingFlag = false;
      this.specialitiesData = [{ id: -2, name: "Dialysis" },{ id: -1, name: "Not Mentioned" }];
    }
  }

  DoctorByName(index, item) {
    return item.name;
  }

  getDoctors(specialityId) {
    this.doctorsData = [];
    if (specialityId) {
      this.selectedSpeciality = specialityId;
      if (specialityId == -1 || specialityId == -2 ) {
        this.doctorsData = [{ DoctorId: -1, DoctorName: "Not Mentioned" }];
      } else {
        this.loadingFlag = true;
        this.askApolloService
          .getDoctorsOnSpeciality(this.selectedHospital, specialityId) // hospitalid, specId
          .subscribe(
            (res: any) => {
              if (res.response.length > 0) {
                this.doctorsData = res.response;
              } else {
                this.doctorsData = [];
                this.messageService.showErrorMessage(
                  "No doctors available for selected speciality."
                );
              }
              this.loadingFlag = false;
            },
            (error) => {
              this.loadingFlag = false;
              this.messageService.showErrorMessage(
                "No doctors available on selected speciality. Please Contact Admin."
              );
            }
          );
      }
    }
  }

  UpdateCallStatusDetails(formData) {
    this.loadingFlag = true;
    let payload = {
      AutoId: this.callerStatusAutoId,
      CallStatus: this.selectedCallStatusId,
      CallSubStatus: +formData.subDisposition,
      CityId: +formData.city,
      ClinicId: +formData.clinic,
      SpecialtyId: +formData.speciality,
      DoctorId: +formData.doctor,
      Remarks: formData.remarks,
      IsActivityLead:
        localStorage.getItem("IsActivityLead") == "true" ? true : false,
    };

    this.callCenterService.UpdateCallStatusDetails(payload).subscribe(
      (res: any) => {
        this.callStatusForm.disable();
        this.messageService.showSuccess(res.response["statusMessage"]);
        this.callCenterService.afterCompleteOperationKnowTheStatus({
          callStatusId: this.selectedCallStatusId,
          callStatusName: this.selectedCallStatusName,
          isOperationDone: true,
          statusMessage: this.selectedCallStatusName + " Status Updated.",
        });
        this.loadingFlag = false;
      },
      (error) => {
        this.loadingFlag = false;
        this.messageService.showErrorMessage(
          "Unable to update call details, An error occur while updating call details."
        );
      }
    );
  }
}
